import {Injectable} from '@angular/core';
import {firstValueFrom, Observable} from 'rxjs';
import {ApiHelperService} from 'src/app/core/helpers/api-helper.service';
import {environment} from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class DataProductsService {

    constructor(
        private api: ApiHelperService,
    ) {
    }

    addGroup(body: any): Observable<any> {
        return this.api.create(environment.DATASET_GROUP_CREATE, body);
    }

    getAllDatasetGroup(params?: any) {
        return this.api.getAll(environment.DATASET_GROUP_GET_ALL, params);
    }

    getDatasetGroupFilter(params?: any) {
        return this.api.getAll(environment.DATASET_GROUP_GET_FILTER, params);
    }

    getGroupDetail(id: any): Observable<any> {
        return this.api.getById(environment.DATASET_GROUP_GET_BY_ID, id);
    }

    editGroup(id: any, body: any): Observable<any> {
        return this.api.updateById(environment.DATASET_GROUP_GET_BY_ID, id, body);
    }

    submitDatasetInfo(body: any): Observable<any> {
        return this.api.create(environment.DATASET_CREATE, body);
    }

    getListDatasetPending(params: any): Observable<any> {
        return this.api.getAll(environment.DATASET_GET_LIST_PENDING, params);
    }

    getListDatasetUpcoming(params: any): Observable<any> {
        return this.api.getAll(environment.DATASET_GET_LIST_UPCOMING, params);
    }

    approveDataset(body: any): Observable<any> {
        return this.api.create(environment.DATASET_APPROVE, body);
    }

    releaseDataset(code: string): Observable<any> {
        return this.api.createChildren(environment.DATASET_RELEASE, { code }, null);
    }

    getDatasetPendingByCode(code: string): Observable<any> {
        return this.api.getChildren(environment.DATASET_GET_PENDING_BY_CODE, { code });
    }

    getAllDatasetList(params?: any) {
        return this.api.getAll(environment.DATASET_GET_ALL, params);
    }

    getDatasetListByGroupId(id: any) {
        return this.api.getById(environment.DATASET_GET_LIST_BY_GROUP_ID, id);
    }

    getDatasetDetail(params?: any) {
        return this.api.getAll(environment.DATASET_GET_BY_CODE, params);
    }

    getDatasetById(id: any): Observable<any> {
        return this.api.getById(environment.DATASET_GET_BY_ID, id);
    }

    updateDatasetInfo(code: any, body: any): Observable<any> {
        return this.api.updateChildren(environment.DATASET_UPDATE, { code }, body);
    }

    deleteDataset(code: string): Observable<any> {
        return this.api.deleteChildren(environment.DATASET_DELETE, { code });
    }

    getFieldList(params?: any) {
        return this.api.getAll(environment.GET_FIELD_LIST, params);
    }

    getFieldListById(id: any): Observable<any> {
        return this.api.getById(environment.DATASET_GET_FIELD_LIST_BY_ID, id);
    }

    queryDataset(body: any) {
        return this.api.create(environment.QUERY_DATASET, body);
    }

    requestExportDataset(body: any) {
        return this.api.create(environment.EXPORT_DATASET_REQUEST, body);
    }

    /** GET export zip; path should include leading slash (e.g. EXPORT_DATASET_DOWNLOAD_ZIP with :fileName replaced). */
    downloadExportZip(path: string) {
        return this.api.getBlobResponse(path);
    }

    getDatasetPreview(params?: any) {
        return this.api.getAll(environment.GET_DATASET_PREVIEW, params);
    }

    async importDatasetFile(formData: any) {
        return await firstValueFrom(this.api.postFormData(environment.DATASET_IMPORT, formData));
    }

    async watermarkDataset(body: any) {
        return await firstValueFrom(this.api.create(environment.DATASET_WATERMARK, body));
    }
}
